import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue'

export function useSearchSummarySplitter({
  splitterContainerOffset = 300,
  splitterMaxOffset = 380,
  yellowCollectionMinHeight = 65,
  yellowCollectionItemHeight = 70
} = {}) {
  const viewportHeight = ref(window.innerHeight)
  const splitterModel = ref(Math.round((viewportHeight.value - splitterContainerOffset) / 2))
  const yellowCollectionVisibleItemsCount = ref(0)
  const hasUserResizedSplitter = ref(false)

  const defaultContainerHeight = computed(() => (
    Math.round((viewportHeight.value - splitterContainerOffset) / 2)
  ))

  const calculatedYellowCollectionHeight = computed(() => (
    yellowCollectionMinHeight + (yellowCollectionVisibleItemsCount.value * yellowCollectionItemHeight)
  ))

  const splitterLimits = computed(() => [
    yellowCollectionMinHeight,
    Math.max(yellowCollectionMinHeight, viewportHeight.value - splitterMaxOffset)
  ])

  const adjustSplitterToYellowCollection = () => {
    if (hasUserResizedSplitter.value) return

    if (!yellowCollectionVisibleItemsCount.value) {
      splitterModel.value = yellowCollectionMinHeight
      return
    }

    splitterModel.value = Math.min(
      calculatedYellowCollectionHeight.value,
      defaultContainerHeight.value
    )
  }

  const handleYellowVisibleItemsCountUpdate = visibleItemsCount => {
    yellowCollectionVisibleItemsCount.value = visibleItemsCount
    adjustSplitterToYellowCollection()
  }

  const handleSplitterResizeStart = () => {
    hasUserResizedSplitter.value = true
  }

  const handleWindowResize = () => {
    viewportHeight.value = window.innerHeight

    nextTick(() => {
      adjustSplitterToYellowCollection()
    })
  }

  const setDefaultSplitSize = () => {
    splitterModel.value = defaultContainerHeight.value
    hasUserResizedSplitter.value = false
  }

  onMounted(() => {
    window.addEventListener('resize', handleWindowResize)
    adjustSplitterToYellowCollection()
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleWindowResize)
  })

  return {
    splitterModel,
    splitterLimits,
    handleYellowVisibleItemsCountUpdate,
    handleSplitterResizeStart,
    setDefaultSplitSize,
    adjustSplitterToYellowCollection,
    hasUserResizedSplitter,
    viewportHeight,
    defaultContainerHeight,
    handleWindowResize,
    yellowCollectionMinHeight,
    yellowCollectionItemHeight
  }
}
